

export const capitalizeString = (s: string) => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();


// MWS => Multi Word String
export const capitalizeMWS = (str: string) => {
    return str.replaceAll("_", " ").toLowerCase().replace(/\b[a-z]/g, (letter)  =>  letter.toUpperCase())
}